<template>
  <div class="form-input">
    <el-input
      v-model="privateValue"
      :type="type"
      :rows="rows"
      :placeholder="placeholder"
      :readonly="readonly"
      :maxlength="maxLength"
    ></el-input>
    <span class="form-input_count" v-if="maxLength">
      {{ privateValue.length }}/{{ maxLength }}
    </span>
  </div>
</template>
<script>
export default {
  name: "FormInput",
  props: {
    type: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    rows: {
      type: Number,
      default: 8,
    },
    maxLength: {
      type: Number,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
  },
  model: {
    event: "change",
    prop: "value",
  },
  data() {
    return {
      privateValue: this.value,
    };
  },
  watch: {
    privateValue(newValue) {
      this.$emit("change", newValue);
    },
  },
};
</script>
<style lang="scss" scoped>
.form-input {
  position: relative;
}
.form-input_count {
  position: absolute;
  right: 10px;
  bottom: 13px;
  color: #999999;
}
</style>
